import { EmailTemplateType } from "@miplatform/types";
import { ENTITY_TYPES } from "../entityTypes/entityTypes";

export const EMAIL_TYPE = {
  SCHEDULE: "Schedule",
  DISPATCH: "Dispatch",
  ORDER_ASSIGNMENT: "OrderAssignment",
  TECHNICIAN_ENROUTE: "TechnicianEnroute",
  CLOSEOUT_AND_UPDATE: "CloseoutAndUpdate",
};

export const RECIPIENT_TYPE = {
  CUSTOMER: "Customer",
  TECHNICIAN: "Technician",
  VENDOR: "Vendor",
  BUILDER: "Builder",
};

export const EMAIL_ENTITY_TYPE = {
  ATTEMPT: "Attempt",
  ORDER: "Order",
  HOME: "Home",
};

export const EMAIL_ENTITY_TYPE_TO_ENTITY_MAP = {
  [EMAIL_ENTITY_TYPE.ATTEMPT]: ENTITY_TYPES.ATTEMPT,
  [EMAIL_ENTITY_TYPE.ORDER]: ENTITY_TYPES.ORDER,
  [EMAIL_ENTITY_TYPE.HOME]: ENTITY_TYPES.HOME,
};

export const EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP = {
  [EmailTemplateType.AppointmentConfirmation]: "Appointment Confirmation",
  [EmailTemplateType.Approved]: "Approved",
  [EmailTemplateType.CloseoutAndCompletionNotice]: "Closeout & Order Update",
  [EmailTemplateType.NonResponse]: "Non-Response",
  [EmailTemplateType.OrderAssignmentNotice]: "Order Assignment",
  [EmailTemplateType.OrderSand]: "Order Sand",
  [EmailTemplateType.RoughCathedralSandDayOne]: "Rough Sand Cathedral Day 1",
  [EmailTemplateType.RoughCathedralSandDayTwo]: "Rough Sand Cathedral Day 2",
  [EmailTemplateType.RoughBuilderSandDayOne]: "Rough Sand Builder Day 1",
  [EmailTemplateType.RoughBuilderSandDayTwo]: "Rough Sand Builder Day 2",
  [EmailTemplateType.TechnicianEnRouteNotice]: "Technician En-Route",
  [EmailTemplateType.TopOutDayOne]: "Top Out Day 1",
  [EmailTemplateType.TopOutDayTwo]: "Top Out Day 2",
  [EmailTemplateType.TrimDayOne]: "Trim Day 1",
  [EmailTemplateType.TrimDayTwo]: "Trim Day 2",
  [EmailTemplateType.UpdateOrder]: "Update Order",
  [EmailTemplateType.SandRequest]: "Sand Request",
  [EmailTemplateType.SandDelivered]: "Sand Delivered",
  [EmailTemplateType.SandCheck]: "Sand Check",
};

export const DISPATCH_EMAIL_TYPE = {
  [EmailTemplateType.AppointmentConfirmation]: "Appointment Confirmation",
  [EmailTemplateType.CloseoutAndCompletionNotice]: "Closeout & Order Update",
  [EmailTemplateType.OrderAssignmentNotice]: "Order Assignment",
  [EmailTemplateType.TechnicianEnRouteNotice]: "Technician En-Route",
};

export const SCHEDULING_EMAIL_TYPE = {
  [EmailTemplateType.RoughBuilderSandDayOne]: "Rough Sand Builder Day 1",
  [EmailTemplateType.RoughBuilderSandDayTwo]: "Rough Sand Builder Day 2",
  [EmailTemplateType.RoughCathedralSandDayOne]: "Rough Sand Cathedral Day 1",
  [EmailTemplateType.RoughCathedralSandDayTwo]: "Rough Sand Cathedral Day 2",
  [EmailTemplateType.TopOutDayOne]: "Top Out Day 1",
  [EmailTemplateType.TopOutDayTwo]: "Top Out Day 2",
  [EmailTemplateType.TrimDayOne]: "Trim Day 1",
  [EmailTemplateType.TrimDayTwo]: "Trim Day 2",
  [EmailTemplateType.UpdateOrder]: "Update Order",
  [EmailTemplateType.SandRequest]: "Sand Request",
  [EmailTemplateType.SandDelivered]: "Sand Delivered",
  [EmailTemplateType.SandCheck]: "Sand Check",
};

export const EMAIL_TYPE_TO_EMAIL_TEMPLATE_TYPE_MAP = {
  [EMAIL_TYPE.SCHEDULE]: [EmailTemplateType.AppointmentConfirmation],
  [EMAIL_TYPE.ORDER_ASSIGNMENT]: [EmailTemplateType.OrderAssignmentNotice],
  [EMAIL_TYPE.TECHNICIAN_ENROUTE]: [EmailTemplateType.TechnicianEnRouteNotice],
  [EMAIL_TYPE.DISPATCH]: [
    EmailTemplateType.TechnicianEnRouteNotice,
    EmailTemplateType.OrderAssignmentNotice,
  ],
  [EMAIL_TYPE.CLOSEOUT_AND_UPDATE]: [
    EmailTemplateType.CloseoutAndCompletionNotice,
  ],
};

export const EMAIL_TYPE_TO_MODAL_MAP = {
  [EMAIL_TYPE.SCHEDULE]: {
    title: "Send Appointment Confirmation",
    description:
      "Select an email to send now. If you skip, the order will remain on the board and you can send later via right-click.",
    action: "Send Appointment Confirmation",
  },
  [EMAIL_TYPE.DISPATCH]: {
    title: "Send Tech En-Route Email & Order Assignment Emails",
    description:
      "Select an email to send now. If you skip, the order will remain on the board and you can send later via right-click.",
    action: "Send Emails",
  },
  [EMAIL_TYPE.CLOSEOUT_AND_UPDATE]: {
    title: "Send Closeout & Order Update Email",
    description:
      "The order has been closed, please create order update email to keep the customer informed.",
    action: "Send Closeout & Order Update Email",
  },
};

export const RECIPIENT_TYPE_OPTIONS = [
  { label: "Assignee", value: "Assignee" },
  { label: "Contact", value: "Contact" },
  { label: "Static Email", value: "Email" },
  { label: "User", value: "User" },
];
export const CALENDAR_EMAIL_TEMPLATE_TYPES = new Set([
  EmailTemplateType.AppointmentConfirmation,
  EmailTemplateType.OrderAssignmentNotice,
  EmailTemplateType.TechnicianEnRouteNotice,
  EmailTemplateType.CloseoutAndCompletionNotice,
  EmailTemplateType.OrderSand,
  EmailTemplateType.NonResponse,
  EmailTemplateType.Approved,
]);
